









import store from '@/store';

export default
  name: 'NormalButton'

  props:
    # ラベル
    label:
      type: String
      default: ''
    type:
      type: String
      default: 'submit'
    reserve:
      type: Boolean
      default: false

  # click: クリックイベント
  methods: {
    click: (e) ->
      @$emit('click')
  }
